import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import Logo from "./homepage/images/logo.png";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { apiInst } from "../hooks/apiHandler";


export const SignupPage = () => {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  useEffect(() => {
    console.log('Signup Page Loaded');
    console.log('Current API URL:', apiInst.defaults.baseURL);
  
  }, [])
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (!agreedToTerms) return;

    if (data.get("password") !== data.get("cpassword")) {
      alert("Password not match");
    } else {
      const resp = await signup({
        uname: data.get("name"),
        email: data.get("email"),
        phone: data.get("phone"),
        password: data.get("password"),
      });
      if (resp) {
        navigate("/login", { replace: true });
      }
    }
  };

  return (<>
    <ArrowBackIcon sx={{color:'#222',marginLeft:'25px',marginTop:'25px',borderRadius:'100%',border:'1px solid #222',fontSize:'32px'}} 
       onClick={() => navigate("/")}></ArrowBackIcon>
  
 
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={Logo} alt="miirapos_logo" width='120px' onClick={() => navigate("/")}></img>
        {/* <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
          <LockOutlinedIcon />
        </Avatar> */}
        <Typography component="h1" variant="h5">
          Sign Up
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              id="name"
              label="Name"
              name="name"
              autoComplete="name"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="phone"
              label="Phone Number"
              type="number"
              id="phone"
              autoComplete="tel"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="new-password"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="cpassword"
              label="Confirm Password"
              type="password"
              id="cpassword"
              autoComplete="new-password"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Typography variant="body2">
                  I agree to the{" "}
                  <Link href="/terms" target="_blank">
                    Terms & Conditions
                  </Link>
                </Typography>
              }
              sx={{ mt: 1 }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={!agreedToTerms}
            >
              Sign Up
            </Button>
          </Box>
          <Grid container>
            <Grid item>
              <Link href="/login" variant="body2">
                {"Already have an account? Login"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
     </>
  );
};
